import React from "react";
import ClearIcon from "app/assets/icons/ClearIcon";

interface IconButtonProps {
  onClick: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
}

const Clear: React.FC<IconButtonProps> = ({
  onClick,
  type = "button",
  disabled = false,
}) => {
  return (
    <button
      type={type}
      className={`w-[15%] md:w-[8%] flex justify-center items-center rounded-[8px] bg-[#1F314E] text-[20px] text-white p-3   transition-colors duration-300 hover:bg-darkgrey disabled:bg-gray-400 disabled:cursor-not-allowed absolute right-[10px] top-[10px] z-50`}
      onClick={onClick}
      disabled={disabled}
    >
      <ClearIcon />
    </button>
  );
};

export default Clear;
